module.exports = __webpack_public_path__ + "static/media/logo.3243c79c.png";